import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { CustomPart } from "../../../stores/slices/packageEditorSlice";
import { Button } from "../../../ui/Button/Button";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../ui/PriceDisplay/PriceDisplay";
import { TrashIcon } from "../../../ui/icons/TrashIcon";
import { PriceSelect } from "../PriceSelect/PriceSelect";

export const CustomPartItem: FunctionComponent<{
  part: CustomPart;
  removeCustomPart(customPartNumber: string): void;
  updateCustomPart(customPart: CustomPart): void;
}> = ({ part, removeCustomPart, updateCustomPart }) => {
  const [language] = useLanguage();
  const { t } = useTranslation();
  const name = language === "fr" ? part.customNameFr : part.customName;
  const typeName =
    language === "fr" ? part.customTypeNameFr : part.customTypeName;

  return (
    <div className="border-t py-4">
      <div className="flex items-center justify-between">
        {name}
        <Button
          aria-label="removeItemFromCart"
          className="text-ink-2 font-light px-2"
          onClick={(): void => removeCustomPart(part.customPartNumber)}
        >
          <TrashIcon />
          <span className="hidden md:inline">{t("cart.remove")}</span>
        </Button>
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <KeyValue>
          <>{t("packageEditor.typeName")}:</>
          <>{typeName}</>
        </KeyValue>
        <KeyValue>
          <>{t("packageEditor.part#")}:</>
          <>{part.customPartNumber}</>
        </KeyValue>
        <PriceSelect
          onChange={(e): void => {
            const quantity = Number(e.target.value);
            if (quantity !== part.quantity) {
              updateCustomPart({ ...part, quantity });
            }
          }}
          className="h-8"
          defaultValue={String(part.quantity)}
        />
        <KeyValue>
          <>{t("packageEditor.price")}:</>
          <PriceDisplay>{part.customPrice}</PriceDisplay>
        </KeyValue>
      </div>
    </div>
  );
};
